export class Scroll {

    static disable() {
        document.body.style.setProperty('overflow', 'hidden', 'important');
    }

    static enable() {
        document.body.style.removeProperty('overflow');
    }
}

window.Scroll = Scroll;